/**
 * Storage Keys
 * 
 * Chức năng: Định nghĩa các key dùng để lưu trữ dữ liệu local
 * Dùng để: 
 * - Lưu access token, refresh token
 * - Lưu thông tin user
 * - Lưu cài đặt theme
 * - Đảm bảo mobile và desktop dùng cùng key names
 * 
 * Note: Keys này được dùng chung cho cả web và mobile app
 * để đảm bảo đồng bộ hóa dữ liệu và cấu trúc
 */
export const STORAGE_KEYS = {
  // Authentication keys (dùng chung)
  ACCESS_TOKEN: 'hrm_access_token',
  REFRESH_TOKEN: 'hrm_refresh_token',
  
  // User data (dùng chung)
  USER_DATA: 'hrm_user_data',
  
  // UI settings (dùng chung)
  THEME_MODE: 'hrm_theme_mode',
  
  // Mobile-specific keys
  BIOMETRIC_ENABLED: 'hrm_biometric_enabled',
  NOTIFICATION_TOKEN: 'hrm_notification_token',
  NOTIFICATIONS_ENABLED: 'hrm_notifications_enabled',
} as const;

